import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="flex flex-wrap items-center gap-1 text-sm text-foreground-500">
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        return (
          <span key={`${item.label}-${index}`} className="inline-flex items-center gap-1">
            {item.to && !isLast ? (
              <Link
                to={item.to}
                className="cursor-pointer transition-colors hover:text-primary-600"
              >
                {item.label}
              </Link>
            ) : (
              <span className={isLast ? "text-foreground-900" : ""}>{item.label}</span>
            )}
            {!isLast ? <i className="ri-arrow-right-s-line text-foreground-400" /> : null}
          </span>
        );
      })}
    </nav>
  );
}